export const PMSTYPES = {
    1: 'Open Dental',
    2: 'Eaglesoft',
}

export enum PMS_Type {
  OpenDental = 1,
  Eaglesoft = 2
}